export enum NotificationType {
  StatusChanged,
}

export enum TypologyValue {
  Discovery = 1,
  Development,
  Diligence,
}

export enum PriorityValue {
  VeryLow = 1,
  Low,
  Medium,
  High,
  Critical,
}

export enum StatusValue {
  Submitted = 1,
  Analysis = 2,
  Blocked = 3,
  Quoted = 4,
  Accepted = 5,
  ToDo = 6,
  OnHold = 7,
  InProgress = 8,
  InQA = 9,
  Pending = 10,
  Canceled = 11,
  Rejected = 12,
  Done = 13,
}

export enum StatusFilter {
  Waiting = 1,
  Analysis = 2,
  Blocked = 3,
  Quoted = 4,
  InProgress = 5,
  InQA = 6,
  Pending = 7,
  Canceled = 8,
  Rejected = 9,
  Done = 10,
}

export enum DashboardColumnStatus {
  Submitted,
  InEvaluation,
  InExecution,
  Concluded,
}

export enum FilterType {
  Time,
  Status,
  Claimant,
  RequireAction,
}

export enum LogicalOperator {
  And = '0',
  Or = '1',
}

export enum OrderByTypeValues {
  Urgency,
  CreationDate,
  Typology,
}

export enum KpiFilterType {
  Typology,
  Claimant,
  Status,
  Reference,
}

export enum KpiOrderByType {
  CreationDateDesc,
  CreationDateAsc,
  Typology,
  Status,
  // Request KPIs
  Claimant,
  // Hours KPIs
  EstimatedHours,
  UsedHours,
}

export enum IssueType {
  Task = 1,
  Document = 2,
  Bug = 3,
  Support = 4,
  DocumentNB = 5,
  BugNB = 6,
  SupportNB = 7,
  TaskNB = 8,
  Meeting = 9,
  MeetingNB = 10,
  Analysis = 11,
  AnalysisNB = 12,
  CodeReview = 13,
}

export type ActivityCategory = 'analysis' | 'execution';

export const ActivityCategories = ['analysis', 'execution'] as const;

export const ActivityCategoryActivityTypes: {
  readonly [K in ActivityCategory]: readonly ActivityType[];
} = {
  analysis: ['meeting', 'analysis'],
  execution: [
    'development',
    'documentation',
    'maintenance',
    'support',
    'code_review',
  ],
} as const;

export const ActivityTypeIssueTypes: {
  readonly [K in ActivityType]: readonly IssueType[];
} = {
  meeting: [IssueType.Meeting, IssueType.MeetingNB],
  analysis: [IssueType.Analysis, IssueType.AnalysisNB],
  development: [IssueType.Task, IssueType.TaskNB],
  maintenance: [IssueType.Bug, IssueType.BugNB],
  support: [IssueType.Support, IssueType.SupportNB],
  documentation: [IssueType.Document, IssueType.DocumentNB],
  code_review: [IssueType.CodeReview],
} as const;

export const BillableIssueTypes: readonly IssueType[] = [
  IssueType.Meeting,
  IssueType.Analysis,
  IssueType.Task,
  IssueType.Bug,
  IssueType.Support,
  IssueType.Document,
  IssueType.CodeReview,
] as const;

export type ActivityType =
  | 'meeting'
  | 'analysis'
  | 'development'
  | 'documentation'
  | 'maintenance'
  | 'support'
  | 'code_review';
